var popUpOverlay, overlayCloseButton, activeOverlayContent;

function openPopUpOverlay(name, selectedValue) {
    activeOverlayContent = document.getElementById('overlay-content-' + (selectedValue ? selectedValue : name));

    if (activeOverlayContent) {
        activeOverlayContent.classList.remove('displayNone');
        jQuery('html, body').animate({ scrollTop: 0 }, 1000);
        setTimeout(function () {
            popUpOverlay.className = 'smoothFadeIn';
        }, 100);
    }
}

function closePopUpOverlay() {
    popUpOverlay.className = 'smoothFadeOut';
    setTimeout(function () {
        popUpOverlay.className = 'displayNone';
        activeOverlayContent.classList.add('displayNone');
    }, 500);
}

function init_main_js() {
    popUpOverlay = document.getElementById('pop-up-overlay');
    overlayCloseButton = document.querySelector('#pop-up-overlay img.close-overlay');

    if (overlayCloseButton) {
        overlayCloseButton.addEventListener('click', closePopUpOverlay);
    }
}

if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", init_main_js, false);
} else {
    window.onload = function () {
        init_main_js();
    };
}

// PWA: Add custom "add to homescreen" button.
// https://developer.chrome.com/blog/app-install-banners-native/#show-the-install-prompt
// https://web.dev/customize-install/
if ('serviceWorker' in navigator) {
	window.addEventListener('load', function() {
		var prompt;

		window.addEventListener('beforeinstallprompt', function(e) {
			console.log('beforeinstallprompt');

			prompt = e;

			if (prompt) {
				hideAddToHomeButtons(false);
			}
		})

		var addElements = document.getElementsByClassName("pwa-add-selector");

		if (addElements !== null) {
			for (var i = 0; i < addElements.length; i++) {
				addElements[i].addEventListener("click", addToHome);
			}
		}

		function hideAddToHomeButtons(hidden) {
			console.log('hideAddToHomeButtons(' + hidden + ')');

			var addElements = document.getElementsByClassName("pwa-button");

			if (addElements !== null) {
				for (var i = 0; i < addElements.length; i++) {
					addElements[i].hidden = hidden;
				}
			}
		}

		function addToHome() {
			console.log('addToHome()');

			if (!prompt) {
				console.log('addToHome(): No "beforeinstallprompt" -> Probably already installed.');
				return;
			}

			prompt.prompt();

			prompt.userChoice.then(function(choiceResult) {
				if (choiceResult.outcome === "accepted") {
					console.log("User accepted the prompt");
					hideAddToHomeButtons(true);
				} else {
					console.log("User dismissed the prompt");
				}

				prompt = null;
			});
		}
	});
}

$(function () {
    $("[data-open-window]").click(function (e) {
        e.preventDefault();
        window.open(this.getAttribute("data-open-window"));
    });
});
